<template>
  <b-container v-if="this.$root.signedIn" class="pt-3">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion1 variant="primary">
          Search Criteria
          <font-awesome-icon icon="caret-down" size="lg" v-if="!showSearch"/> 
          <font-awesome-icon icon="caret-up" size="lg" v-if="showSearch"/>
        </b-btn>
      </b-card-header>
      <b-collapse id="accordion1" visible accordion="accordion1" role="tabpanel" v-model="showSearch">
        <b-row class="pt-2">
          <b-col>
            <scoring-event-search 
              :skip = "{}"
              :multiple = "{
                region: true,
                industry: true,
                programme: true,
                year: true,
                customer: true
              }"
              horizontal
              @update:customer = "customers = $event"
              @update:industry = "industries = $event" 
              @update:country = "country = $event"
              @update:region = "regions = $event"
              @update:gear = "gear = $event"
              @update:programme = "programmes = $event"
              @update:year = "years = $event"
            />
          </b-col>
        </b-row>
        <b-row class="pt-3 pb-3">
          <b-col class="text-center">
            <b-button variant="success" @click="search()" v-if="!loading">Search</b-button>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-row v-if="loading" align-h="center" class="text-left">
      <font-awesome-icon icon="spinner" size="lg" spin/>
    </b-row>
  
    <table class="table table-striped" v-if="!loading">
      <thead>
        <tr>
          <th>Programme</th>
          <th>Country</th>
          <th>Customer</th>
          <th>Period/Year</th>
          <th>
            Actions
            <br>
            <small>Details Download Delete</small>
          </th>
          <th></th>
          <th><small>Analyse Multiple</small>
            <router-link :to="{path: '/multi-analyse', query: {scoringEventIds: multiAnalyseIds }}">
              <font-awesome-icon icon="clone" size="1x" alt="Analyse multiple scoring events"/>
            </router-link>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id" class='c'>
          <td>{{ item.programme.name }}</td>
          <td>{{ item.customer.country }}</td>
          <td>{{ item.customer.name }}</td>
          <td>{{ item.period }}&nbsp;{{ item.year }}</td>
          <td>
            <span class="pr-3">
              <router-link :to="`scoring-event/${item.id}`">
                <font-awesome-icon icon="info" size="lg"/>
              </router-link>
            </span>
            <span class="pr-3">
              <a class='clickable' @click="download(item)" v-if="!downloading">
                <font-awesome-icon icon="file-download" size="lg"/>
              </a>
              <font-awesome-icon icon="spinner" size="lg" spin v-if="downloading"/>
            </span>
          </td>
          <td>
              <b-button-group vertical>
                <b-button variant="primary" @click="edit(item.id)" :css="'btn btn-sm'">Edit</b-button>              
                <vue-confirmation-button :css="' btn btn-danger btn-sm'" :messages="['Delete','Are you sure?','Deleted, reloading.....']" @confirmation-success="deleteRun(item)"/>
              </b-button-group>
          </td>
          <td>
            <input type="checkbox" @click="updateMultiAnalyse($event, item.id);">
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination size="sm" :total-rows="total" v-model="page" :per-page="pageSize" v-if="total > 0"/>
  </b-container>
</template>
<script>
import * as API from "@/services/API";
import vueConfirmationButton from 'vue-confirmation-button';
import ScoringEventSearch from '@/components/ScoringEventSearch.vue';

export default {
  name: 'SurveyList',
  // properties you can pass to this component
  props: {},
  components: { 
    vueConfirmationButton,
    ScoringEventSearch
  },
  watch: {
    // next page
    page: function(val) {
      this.search();
    },
    pageSize: function(val) {
      this.search();
    }
  },
  // this is reactive data and will be updated in the view
  data: function () {
    return {
      items: [],
      total: 0,
      page: 1,
      pageSize: 10,
      downloading: false,
      multiAnalyseIds: [],
      loading: true, 
      showSearch: false,
      toDelete: null,
      customers: [],
      programmes: [],
      industries: [],
      country: null,
      regions: [],
      gear: null,
      years: []
    };
  },
  created: function () {
    this.search();
  },
  methods: {
    edit(id){
      this.$router.push('/edit-scoring-event/'+id);
    },
    search() {
      this.loading = true;
      this.showSearch = false;
      const searchBody = {
        industries: this.industries,
        gear: this.gear,
        years: this.years,
        country: this.country,
        regions: this.regions,
        customer_id: this.customers.map(customer => customer.id),
        programme_id: this.programmes.map(programme => programme.id),
        page: this.page,
        pageSize: this.pageSize
      };
      
      // clean out nulls
      Object.keys(searchBody).forEach(field => {
        if (!searchBody[field] || searchBody[field].length === 0) delete searchBody[field];
      });

      return API.searchSurveyRuns(searchBody).then(res => {
        this.loading = false;
        this.items = res.body.results;
        this.total = res.body.total;
      });
    },
    forceFileDownload(response, filename){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      // no filename in response :(
      link.setAttribute('download', filename) // have to specify a filename here
      document.body.appendChild(link)
      this.downloading = false;
      link.click()
    },
    download: function(survey_run) {
      this.downloading = true;
      return API.getExcelReport(survey_run.id, null, 'full').then(response => {
        this.forceFileDownload(response, `${survey_run.survey_monkey_name.replace(/\s/g, '_')}_auto_analysis.xlsx`)
      })
    },
    updateMultiAnalyse: function(event, itemId) {
      if (event.srcElement.checked && this.multiAnalyseIds.indexOf(itemId) === -1) this.multiAnalyseIds.push(itemId);
      if (!event.srcElement.checked && this.multiAnalyseIds.indexOf(itemId) !== -1) this.multiAnalyseIds.splice(this.multiAnalyseIds.indexOf(itemId), 1);
    },
    deleteRun: function(survey_run) {
      var that = this;
      return API.deleteSurveyRun(survey_run.id).then(response => {
        window.setTimeout(function() {
          that.search();
        }, 3000);
        
      });
    }
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/SurveyList.vue